import React from 'react';
import { useParams } from 'react-router-dom';
import { GameProvider } from '../../context/GameContext';
import MultiplayerGameComponent from '../MultiplayerGame/MultiplayerGame';

// GamePlayPage: Router wrapper for main game UI (desktop style, mobile optimized)
const GamePlayPage: React.FC = () => {
  const { roomId } = useParams();
  return (
    <GameProvider>
      <MultiplayerGameComponent roomId={roomId} skipModal={true} />
    </GameProvider>
  );
};

export default GamePlayPage;
